import { render, staticRenderFns } from "./PageCoursesStudent.vue?vue&type=template&id=c0b754a8&scoped=true&"
import script from "./PageCoursesStudent.vue?vue&type=script&lang=js&"
export * from "./PageCoursesStudent.vue?vue&type=script&lang=js&"
import style0 from "./PageCoursesStudent.vue?vue&type=style&index=0&id=c0b754a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b754a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VImg,VProgressLinear,VSheet})
